// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
export { ApplicationInsights } from "./JavaScriptSDK/ApplicationInsights";
//# sourceMappingURL=applicationinsights-analytics-js.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@microsoft/applicationinsights-analytics-js/dist-esm/applicationinsights-analytics-js.js
// module id = 220
// module chunks = 42